import { loadQuery, type PreloadedQuery } from 'react-relay';
import {
	createOperationDescriptor,
	type CacheConfig,
	type PayloadError,
	type OperationDescriptor,
	type IEnvironment,
} from 'relay-runtime';

import query, {
	type ViewPagePersonalizationQuery as PersonalizationQuery,
} from './__generated__/ViewPagePersonalizationQuery.graphql.ts';

/** One physical execution. The route owner, not preload completion, releases its retain. */
export class PersonalizationQueryReference {
	readonly reference: PreloadedQuery<PersonalizationQuery>;
	readonly ready: Promise<void>;
	readonly operation: OperationDescriptor;
	errors: ReadonlyArray<PayloadError> = [];
	hasUnscopedErrors = false;
	failed = false;
	settled = false;
	disposed = false;
	private finish: () => void;
	private unsubscribe: () => void = () => {};

	constructor(
		environment: IEnvironment,
		readonly variables: PersonalizationQuery['variables'],
		networkCacheConfig?: CacheConfig,
		storeOnly = false,
	) {
		this.operation = createOperationDescriptor(query, variables);
		let resolveReady: () => void = () => {};
		this.ready = new Promise<void>((resolve) => {
			resolveReady = resolve;
		});
		this.finish = () => {
			this.settled = true;
			resolveReady();
		};
		this.reference = loadQuery<PersonalizationQuery>(environment, query, variables, {
			fetchPolicy: storeOnly ? 'store-only' : 'store-or-network',
			networkCacheConfig,
		});
		const subscription = this.reference.source?.subscribe({
			next: (response) => {
				const errors = (Array.isArray(response) ? response : [response]).flatMap((payload) =>
					'errors' in payload ? (payload.errors ?? []) : [],
				);
				this.hasUnscopedErrors ||= errors.some(({ path }) => !path?.length);
				this.errors = [...this.errors, ...errors];
			},
			error: () => {
				this.failed = true;
				this.finish();
			},
			complete: this.finish,
		});
		this.unsubscribe = () => subscription?.unsubscribe();
		if (!this.reference.source) this.finish();
	}

	dispose(): void {
		if (this.disposed) return;
		this.disposed = true;
		this.unsubscribe();
		this.reference.dispose();
		this.finish();
	}
}
